/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {AvatarConfigService as ɵb} from './lib/avatar-config.service';
export {AVATAR_CONFIG as ɵc} from './lib/avatar-config.token';
export {SourceFactory as ɵa} from './lib/sources/source.factory';